<Navbar/>
<div class="row mt-3">
    <div class="col-md-4 d-none d-lg-block ">
      <div class="d-flex flex-row ms-2">
      <p class="">
        <img src="@/assets/images/search-database.png" class="w-50" alt="" data-bs-toggle="offcanvas" href="#menu_items" role="button" aria-controls="all_portals">
        <!-- <i class="bx bx-menu fs-3" ></i> -->
        </p>
      <p class="mx-4 text-xs mt-1">{{current_date}}</p>
      </div>
       
    </div>
    <div class="col-12 col-sm-12 col-md-4 text-lg-center">
       <h3 class="underline-heading">{{$route.params.portal_name}}.</h3>
    </div>
    <div class="col-6 col-sm-6 col-md-4 d-none d-lg-block">

    <div class="d-flex float-end px-3">
       <CreateTagCategory/>
        <p class="">
           <img src="@/assets/images/letter-p.png"  class="w-50" alt="" data-bs-toggle="offcanvas" href="#all_portals" role="button" aria-controls="all_portals">
        </p>
        
    </div>
    </div>

</div>

<!-- Tab Contents -->
<div class="tab-content">
  <!-- Your Feed -->
  <div v-if="activeVoiceTab === 'your_feed'">
    <!-- Filters -->
<div class="d-flex flex-column align-items-center px-3">
  <!-- Categories -->
  <div class="w-100 text-center text-xxs">
    <div class="d-flex justify-content-center flex-wrap gap-2 mb-3">
      <button v-for="category in categoryOptions" :key="category"
        class="btn bg-transparent border-0 border-bottom border-3 btn-sm text-xxs" :class="{
          'border-secondary text-secondary': selectedCategory === category,
          'border-light text-dark': selectedCategory !== category
        }" @click="handleCategoryClick(category)">
        {{ category }}
      </button>
    </div>

    <!-- Tags -->
    <div v-if="selectedCategory !== 'all' && tagOptions.length > 0"
      class="d-flex justify-content-center flex-wrap gap-2 mb-3">
      <button v-for="tag in tagOptions" :key="tag" class="btn bg-transparent border-0 border-bottom border-3" :class="{
          'border-primary text-primary fw-bold': selectedTag === tag,
          'border-light text-dark': selectedTag !== tag
        }" @click="selectedTag = tag">
        {{ tag }}
      </button>
    </div>
  </div>
</div>

    <div class="justify-content-lg-center px-5">
      <CreateFeed @new_report="add_report"/>
    </div>
     <div class="bbc-news-grid container">
    <div 
      v-for="(report, index) in filtered_reports"
      :key="report.id"
      :class="['bbc-card', getCardSize(index)]"
    >
         <router-link :to="`/view_full_report/${report.id}/${$route.params.portal_id}/${$route.params.portal_name}`" class="text-decoration-none text-dark">
          <div class="card mb-4 shadow-sm border-0 rounded-5 h-100">
            <div v-for="(fileObj, index) in report.report_files" :key="index" >
                        <!-- Image -->
                        <img v-if="fileObj.file.file_url.includes('.jpg') ||
                                      fileObj.file.file_url.includes('.png') || 
                                      fileObj.file.file_url.includes('.jpeg')" :src="fileObj.file.file_url"
                          alt="Feed Image" class="img-fluid image-blog w-100"
                        />

                        <!-- Audio -->
                        <audio v-else-if="fileObj.file.file_url.includes('.mp3') ||
                                            fileObj.file.file_url.includes('.wav')" controls class="w-100">
                          <source :src="fileObj.file.file_url" type="audio/mp3">
                          Your browser does not support the audio element.
                        </audio>

                        <!-- Video -->
                        <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls
                          class="img-fluid rounded-5 w-100" @click="display_comment_modal(report)">
                          <source :src="fileObj.file.file_url" type="video/mp4">
                          Your browser does not support the video tag.
                        </video>

                        <div v-else class="uploaded-file m-2" @click="display_comment_modal(report)">
                          <img :src="getFileIcon(fileObj.file.file_url)" class="file-icon small-icon" />
                          <span class="file-name">{{ getFileName(fileObj.file.file_url) }}</span>
                          <a :href="fileObj.file.file_url" download :title="getFileName(fileObj.file.file_url)"
                            class="download-btn" @click.stop>
                            <img src="https://cdn-icons-png.flaticon.com/128/724/724933.png" class="download-icon" />
                          </a>
                        </div>

                      </div>  
              <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <!-- {{$route.params.portal_name}} -->
                <p class="text-muted mb-1 text-xxs mb-0">
  {{
    report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'years')
      ? `${report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'years').name} (Year)`
      : report.publication_date
  }}
  &nbsp; | &nbsp;
  <router-link
  :to="`/view_full_report/${report.id}/${$route.params.portal_id}/${$route.params.portal_name}`"
  class="text-decoration-none text-dark"
>
  {{
    report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'authors')?.name
      ? `${report.tags.find(tag => tag.tag_category.name.toLowerCase() === 'authors')?.name} (Author)`
      : report.creater?.first_name && report.creater?.last_name
        ? `${report.creater.first_name} ${report.creater.last_name}`
        : report.creater?.company_name
  }}
</router-link>

</p>



                <div class="dropdown">
                  <a href="#" class="fw-bold text-dark text-end" id="dropdownMenuButton" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    <i class="bi bi-three-dots-vertical"></i>
                  </a>
                  <ul class="dropdown-menu custom-dropdown lh-1" aria-labelledby="dropdownMenuButton">
                    <li>
                      <a class="dropdown-item text-xs fw-bold" href="#"
                        @click.prevent="delete_report(report.id)">
                        <i class="bx bxs-trash-alt fs-6"></i> Delete
                      </a>
                    </li>
                     <li v-if="String(report.creater?.base_profile?.creater.id) === String(user_details.user_id) || String(report.creater.id) === String(user_details.user_id)">
                        <a class="dropdown-item text-xs fw-bold" href="" data-bs-toggle="modal"
                          data-bs-target="#edit_report_modal" @click="edit_report(report)"
                          >
                          <i class="bx bxs-edit fs-6"></i> Edit
                        </a>
                    </li>
                   
                  </ul>
                </div>
              </div>
              <div class="mt-2 mb-2">

  <span v-for="tag in get_filtered_tags(report.tags)" :key="tag.id" class="badge bg-primary me-1 text-capitalize">
    {{ tag.name }}
  </span>
</div>
                  <p class="card-text text-muted text-xs" v-html="get_description(report)"></p>

                  <a
                    v-if="report.description && report.description.length > 250"
                    href="#"
                    @click.prevent="toggle_description(report.id)"
                    class="text-secondary text-decoration-none fw-bold text-xs"
                  >
                    {{ expandedReports.includes(report.id) ? 'Read less' : 'Read more' }}
                  </a>
                  <div v-if="String(report.creater?.id) !== String(user_details.user_id) && user_details.user_role === 'admin' && report.status?.name === 'pending' " class="mt-3 d-flex gap-2 ">
  <button
    class="btn btn-sm btn-success rounded-pill px-3"
    @click.stop.prevent="approve_report(report.id)"
  >
    <i class="bi bi-check-circle me-1"></i> Approve
  </button>
  <button
    class="btn btn-sm btn-danger rounded-pill px-3"
    @click.stop.prevent="reject_report(report.id)"
  >
    <i class="bi bi-x-circle me-1"></i> Reject
  </button>
</div>
            </div>      

         </div>
      </router-link>
      </div>
    </div>
  </div>

  <!-- Voice Tab -->
  <div v-if="activeVoiceTab === 'voice'">
    <SurveyView/>
  </div>

  <!-- Portal Requests Tab -->
  <div v-if="activeVoiceTab === 'requests'">
    <PortalRequest/>
  </div>

  <!-- Documents Tab -->
  <div v-if="activeVoiceTab === 'documents'">
   <DocumentApproval/>
  </div>

  <!-- Warehouse Tab -->
  <div v-if="activeVoiceTab === 'warehouse'">
     <DocumentWarehouse/>
  </div>
</div>


<div class="offcanvas offcanvas-start" tabindex="-1" id="menu_items" aria-labelledby="menu_items_label">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ul class="nav nav-pills d-flex flex-column mt-5" role="tablist">
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'your_feed' }"
          @click="activeVoiceTab = 'your_feed'">
          News & Articles
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
           data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'voice' }"
          @click="activeVoiceTab = 'voice'">
          Voice
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
           data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'requests' }"
          @click="activeVoiceTab = 'requests'">
          Portal requests
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
           data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'documents' }"
          @click="activeVoiceTab = 'documents'">
          Document/Media Approval
        </button>
      </li>
      <li class="nav-item text-center ms-2 mt-2" role="presentation">
        <button 
          class="nav-link text-xs fw-500" 
          data-bs-dismiss="offcanvas"
          :class="{ active: activeVoiceTab === 'warehouse' }"
          @click="activeVoiceTab = 'warehouse'">
          Document Warehouse
        </button>
      </li>
    </ul>
  </div>
</div>

<div class="offcanvas offcanvas-end" tabindex="-1" id="all_portals" aria-labelledby="all_portals_label">
  <div class="offcanvas-header">
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <AllPortals data-bs-dismiss="offcanvas"/>
  </div>
</div>


<div class="modal fade" id="edit_report_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">edit your feed</h5>
        <button type="button" class="btn-close  text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="edit_report_data">
        <div class="modal-body">
          <QuillEditor theme="snow" v-model="report_description" ref="quillReportRef" class="quill-editor"
            toolbar="full" />
          <div class="d-flex mt-2 mx-1 justify-content-between align-items-start">
            <div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-center">
              <label for="editReportFileInput"
                class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                <i class='bx bx-image-add file-upload-icon'></i> Add Feed content
              </label>
              <input type="file" id="editReportFileInput" class="file-input d-none" @change="handleHomeFileUpload" />
              <div v-if="editFileName" class="text-xs text-secondary fst-italic mt-1">
                <span class="fw-500">File name:</span> {{ editFileName }}
              </div>
              <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>
            </div>
            <div class="file-upload ms-5 my-2 mx-3 flex-grow-1 d-flex flex-column align-items-center">
              <label for="audioInput"
                class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
                <i class='bx bx-music'></i> Upload Audio
              </label>
              <input type="file" accept="audio/*" id="audioInput" class="file-input d-none"
                @change="handleAudioUpload" />
              <div v-if="audioError" class="text-xs text-danger fst-italic mt-1">{{ audioError }}</div>
            </div>
            <div class="d-flex flex-column align-items-center my-2 flex-grow-1">
              <div class="d-flex flex-row align-items-center mb-3">
                <button type="button"
                  class="btn btn-primary text-xs rounded-5 mx-2 d-flex align-items-center justify-content-center"
                  @click="startRecording" v-if="!isRecording">
                  <i class='bx bx-microphone'></i> Record
                </button>
                <button type="button"
                  class="btn btn-danger text-xs rounded-5 mx-2 d-flex align-items-center justify-content-center"
                  @click="stopRecording" v-if="isRecording">
                  <i class='bx bx-stop'></i> Stop
                </button>
              </div>
              <div v-if="audio_file_name" class="text-xs text-secondary fw-500 mb-3 audio-file">
                <i class='bx bx-music'></i> Recorded: {{ audio_file_name }}
              </div>
            </div>
          </div>
          <div class="d-flex flex-column" v-if="edit_documents.report_files && edit_documents.report_files.length">
            <div class="row g-3">
              <div v-for="(fileObj, index) in edit_documents.report_files" :key="index"
                class="col-4 position-relative mb-3">

                <!-- Image -->
                <img
                  v-if="fileObj.file.file_url.includes('.jpg') || fileObj.file.file_url.includes('.png') || fileObj.file.file_url.includes('.jpeg')"
                  :src="fileObj.file.file_url" alt="Feed Image" class="img-fluid rounded-5 w-100 h-50"
                  :class="{ 'zoomed-in': isZoomed }" @click="display_comment_modal(report)" ref="image" />

                <!-- Audio -->
                <audio v-else-if="fileObj.file.file_url.includes('.mp3') || fileObj.file.file_url.includes('.wav')"
                  controls class="w-100 rounded-5">
                  <source :src="fileObj.file.file_url" type="audio/mp3" />
                  Your browser does not support the audio element.
                </audio>

                <!-- Video -->
                <video v-else-if="fileObj.file.file_url.includes('.mp4')" controls class="img-fluid rounded-5 w-100">
                  <source :src="fileObj.file.file_url" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                <!-- PDF -->
                <iframe v-else-if="fileObj.file.file_url.includes('.pdf')"
                  :src="'https://docs.google.com/viewer?url=' + encodeURIComponent(fileObj.file.file_url) + '&embedded=true'"
                  frameborder="0" width="100%" height="500px">
                </iframe>

                <!-- Word Document -->
                <iframe v-else-if="fileObj.file.file_url.includes('.docx') || fileObj.file.file_url.includes('.doc')"
                  :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                  class="img-fluid rounded-5 w-100">
                </iframe>

                <!-- Excel Document -->
                <iframe v-else-if="fileObj.file.file_url.includes('.xls') ||
                                      fileObj.file.file_url.includes('.xlsx') ||
                                      fileObj.file.file_url.includes('.xlsm') ||
                                      fileObj.file.file_url.includes('.xlsb')"
                  :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(fileObj.file.file_url)"
                  frameborder="0" width="100%" height="500px">
                </iframe>

                <!-- Zoom Button -->
                <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')" @click="toggleZoom"
                  class="zoom-btn btn btn-light position-absolute top-0 end-0 m-2 bg-transparent rounded-5">
                  <i :class="isZoomed ? 'bx bxs-zoom-out fs-5 text-white' : 'bx bxs-zoom-in fs-5 text-white'"></i>
                </button>

                <!-- Fullscreen Button -->
                <button v-if="!fileObj.file.file_url.includes('.mp3') &&
                                !fileObj.file.file_url.includes('.wav')" @click="toggleFullscreen"
                  class="fullscreen-btn position-absolute btn btn-light top-0 start-0 m-2">
                  <i class="bi bi-arrows-fullscreen"></i>
                </button>

              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Post</button>
        </div>
      </form>
    </div>
  </div>
</div>

<StickyNav/>